module.exports = __webpack_public_path__ + "static/media/studio-project-icon.074ab6b9.png";